import { render, staticRenderFns } from "./reliableHome.vue?vue&type=template&id=185400f1&scoped=true"
import script from "./reliableHome.vue?vue&type=script&lang=js"
export * from "./reliableHome.vue?vue&type=script&lang=js"
import style0 from "./reliableHome.vue?vue&type=style&index=0&id=185400f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185400f1",
  null
  
)

export default component.exports